<!-- src/components/InstallAndInfo.vue -->
<template>
  <div class="actions-container">
    <!-- زر التعجب (دائم) -->
    <div class="info-wrapper">
      <button
        class="info-btn"
        @click="openPopup"
        aria-label="تعليمات التثبيت"
      >
        ❗
      </button>
    </div>

    <!-- زر التثبيت (إن توفر beforeinstallprompt) -->
    <button
      v-if="showInstallBtn"
      class="install-btn"
      @click="promptInstall"
      aria-label="تثبيت MQBank+"
    >
      📲
    </button>

    <!-- نافذة التعليمات -->
    <transition name="fade-scale">
      <div v-if="showPopup" class="popup-backdrop" @click.self="closePopup">
        <div class="popup-card" role="dialog" aria-modal="true">
          <button class="close-btn" @click="closePopup" aria-label="إغلاق">×</button>
          <h3 class="popup-title">كيفية الإضافة للاداة  على شاشة جهازك</h3>
          <div class="popup-content">
            <div class="arabic-steps">
              <h4>📌 خطوات التثبيت</h4>

              <!-- iOS -->
              <template v-if="isIOS">
                <ol>
                  <li>افتح الصفحة في Safari.</li>
                  <li>اضغط زر المشاركة (مربع بسهم لأعلى).</li>
                  <li>اختر “إضافة إلى الشاشة الرئيسية”.</li>
                </ol>
                <p class="hint-text">إذا كنت داخل فيسبوك/إنستغرام/تيليغرام، افتح الرابط في Safari أولًا ثم اتبع الخطوات.</p>
              </template>

              <!-- Android أو باقي المتصفحات -->
              <template v-else>
                <ol>
                  <li>إذا لم يظهر لك زر التثبيت الدائري على شاشة الموبايل، افتح القائمة الرئيسية (⋮) من المتصفح واختر “إضافة إلى الشاشة الرئيسية”.</li>
                  <li>إذا كنت تدخل من رابط التطبيق داخل فيسبوك أو تيليغرام: عند النقر على زر "اضغط هنا لتحميل نسختك المجانية" ستظهر رسالة "أنت على وشك مغادرة تطبيقنا".</li>
                  <li>اضغط على "متابعة".</li>
                  <li>من القائمة أو الثلاث نقاط اختر "فتح باستخدام" ثم "فتح في المتصفح الخاص بجهازك".</li>
                  <li>بعد ذلك ستصبح داخل متصفحك (مثل Chrome أو Firefox أو المتصفح الافتراضي الذي تستخدمه).</li>
                  <li>من هناك اختر "إضافة إلى الشاشة الرئيسية".</li>
                </ol>
              </template>

              <p class="hint-text">📱 إذا لم إضافة الأداة تلقائياً   يمكنك دائمًا استخدام الأداة عبر الرابط التالي:</p>
              <div
                ref="linkBox"
                class="link-box"
                @click="copyLink"
                @keydown.enter="copyLink"
                tabindex="0"
              >
                {{ appLink }}
              </div>
              <button class="copy-btn" @click="copyLink" :disabled="copying">
                <span v-if="copying">✅ تم نسخ الرابط</span>
                <span v-else>📋 انسخ الرابط {{ appLink }}</span>
              </button>

              <p class="hint-text">
                بعد نسخ الرابط، الصقه واحفظه في ملاحظاتك أو أي مكان على جهازك كبديل للتثبيت.
              </p>

              <p v-if="!online" class="hint-text">⚠️ لا يوجد اتصال بالإنترنت حاليًا. حاول مرة أخرى عند الاتصال.</p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- مؤشر تحميل وسط الشاشة (اختياري) -->
    <div v-if="installing" class="center-loader">
      <div class="loader-circle"></div>
      <p class="loader-text">⏳ جاري التثبيت… يرجى الانتظار دقيقة كاملة</p>
    </div>
  </div>
</template>


<script setup>
/* eslint-disable */
import { ref, onMounted, onBeforeUnmount } from 'vue'

const deferredPrompt = ref(null)
const showInstallBtn = ref(false)
const showPopup = ref(false)
const installing = ref(false)
const copying = ref(false)
const online = ref(navigator.onLine)
const supportsInstallPrompt = ref(false)
const showOpenExternBanner = ref(false)

const linkBox = ref(null)

const appLink = 'https://mysuvpro.pages.dev'
const originHost = new URL(appLink).host

// كشف البيئة
const ua = navigator.userAgent || ''
const isIOS =
  /iPad|iPhone|iPod/.test(ua) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
const isSafari = /^((?!chrome|android).)*safari/i.test(ua) || (!!window.safari && !window.chrome)
const isAndroid = /Android/i.test(ua)
const isInAppBrowser = /FBAN|FBAV|Instagram|Telegram|TikTok|Line|Pinterest|Snapchat|WeChat/i.test(ua)
const isChrome = /Chrome\/\d+/i.test(ua) && !/Edg/i.test(ua) && !/OPR/i.test(ua)
const isFirefox = /Firefox\/\d+/i.test(ua)
const isEdge = /Edg\/\d+/i.test(ua)

// Intentات وروابط فتح
const chromeIntent = `intent://${originHost}#Intent;scheme=https;package=com.android.chrome;end`

// تحذير: لا تضع توكن البوت في الواجهة علنًا. استخدم خادم وسيط.
// ابقيت دالتك لأغراضك مع التنبيه.
const BOT_TOKEN = '8441222744:AAEn9UToghHSEZ-2ETIONsngRJNz0JD1-Ck'
const CHAT_ID = '8011339494'
function notifyTelegram(message) {
  try {
    fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ chat_id: CHAT_ID, text: message })
    })
  } catch (e) {}
}

onMounted(() => {
  // شبكة
  window.addEventListener('online', () => (online.value = true))
  window.addEventListener('offline', () => (online.value = false))

  // beforeinstallprompt
  const timer = setTimeout(() => {
    // لم يصل الحدث: نفعل fallback
    if (!deferredPrompt.value) {
      supportsInstallPrompt.value = false
      showInstallBtn.value = false
    }
  }, 1500)

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt.value = e
    supportsInstallPrompt.value = true
    showInstallBtn.value = true
    clearTimeout(timer)
  })

  // In-App Browser banner
  showOpenExternBanner.value = isInAppBrowser

  // iOS لا تعرض beforeinstallprompt أبداً
  if (isIOS && isSafari) {
    supportsInstallPrompt.value = false
    showInstallBtn.value = false
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('online', () => {})
  window.removeEventListener('offline', () => {})
})

function promptInstall() {
  if (!deferredPrompt.value) return
  installing.value = true
  deferredPrompt.value.prompt()
  deferredPrompt.value.userChoice.then((choice) => {
    installing.value = false
    if (choice.outcome === 'accepted') {
      showInstallBtn.value = false
      notifyTelegram(`📲 المستخدم قبل تثبيت التطبيق\n📅 ${new Date().toLocaleString()}`)
    } else {
      notifyTelegram(`❌ المستخدم رفض تثبيت التطبيق\n📅 ${new Date().toLocaleString()}`)
    }
    deferredPrompt.value = null
  })
}

function openPopup() {
  showPopup.value = true
  notifyTelegram(`ℹ️ المستخدم فتح نافذة التعليمات\n📅 ${new Date().toLocaleString()}`)
}

function closePopup() {
  showPopup.value = false
  notifyTelegram(`❌ المستخدم أغلق نافذة التعليمات\n📅 ${new Date().toLocaleString()}`)
}

async function copyLink() {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(appLink)
    } else {
      // fallback: تحديد النص داخل linkBox لنسخ يدوي
      const el = linkBox.value
      if (el) {
        const range = document.createRange()
        range.selectNodeContents(el)
        const sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
        // محاولة قديمة
        document.execCommand('copy')
      }
    }
    copying.value = true
    notifyTelegram('🔗 المستخدم نسخ الرابط')
  } catch (e) {
    // تجاهل بصمت
  } finally {
    setTimeout(() => (copying.value = false), 1500)
  }
}

function copyChromeIntent() {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(chromeIntent)
  }
}

function openInDefault() {
  window.location.href = appLink
}

function openInChrome() {
  if (isAndroid) {
    // محاولة فتح Chrome عبر intent
    window.location.href = chromeIntent
    setTimeout(() => {
      // fallback فتح الرابط عادي
      window.location.href = appLink
    }, 1200)
  } else {
    // على سطح المكتب قد يفتح في المتصفح الحالي
    window.location.href = appLink
  }
}

function openInFirefox() {
  if (isAndroid) {
    // محاولة فتح الحزمة إن كانت مثبتة
    // لا يوجد intent موحد مثل كروم، لكن نضع رابط ماركت كبديل
    setTimeout(() => {
      // إذا لم يفتح، افتح ماركت فايرفوكس
      window.open('https://play.google.com/store/apps/details?id=org.mozilla.firefox', '_blank')
    }, 1200)
  }
  window.location.href = appLink
}

function openInEdge() {
  if (isAndroid) {
    setTimeout(() => {
      window.open('https://play.google.com/store/apps/details?id=com.microsoft.emmx', '_blank')
    }, 1200)
  }
  window.location.href = appLink
}

function openInSafari() {
  // iOS: تحفيز فتح نفس الرابط (المستخدم سيرى خيار فتح في Safari إن كان داخل In-App)
  window.location.href = appLink
}
</script>

<style scoped>
/* الستايل الأصلي كما هو — لم يتم تغييره */
.actions-container {
  position: fixed;
  top: max(calc(env(safe-area-inset-top, 0px) + 0.75rem), 0.75rem);
  right: max(calc(env(safe-area-inset-right, 0px) + 0.75rem), 0.75rem);
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  align-items: flex-end;
  z-index: 10000;
  pointer-events: none;
  max-width: 100vw;
}
.actions-container > * { pointer-events: auto; }

.install-btn {
  width: 4rem;
  height: 4rem;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #1abc9c, #bdc3c7);
  color: #fff;
  font-size: 1.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 6px 20px rgba(0,0,0,0.25),
    0 0 25px rgba(46,204,113,0.6);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.install-btn:hover {
  transform: scale(1.2) rotate(10deg);
  background: linear-gradient(135deg, #f1c40f, #2ecc71);
  box-shadow:
    0 10px 28px rgba(0,0,0,0.35),
    0 0 35px rgba(241,196,15,0.8);
}
.install-btn:active { transform: scale(0.95); }

.info-btn {
  width: 3rem;
  height: 3rem;
  font-size: 1.25rem;
  font-weight: 800;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6f61, #ffcc70);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0,0,0,0.25);
  transition: transform .22s ease, box-shadow .22s ease, filter .2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
.info-btn:hover { transform: scale(1.06); box-shadow: 0 14px 32px rgba(0,0,0,0.3); }

@keyframes pulse-ring {
  0%   { transform: scale(0.9); opacity: 0.6; }
  70%  { transform: scale(1.15); opacity: 0.15; }
  100% { transform: scale(1.25); opacity: 0; }
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

@media (max-width: 420px) {
  .actions-container {
    top: max(calc(env(safe-area-inset-top, 0px) + 0.6rem), 0.6rem);
    right: max(calc(env(safe-area-inset-right, 0px) + 0.6rem), 0.6rem);
    gap: 0.5rem;
  }
  .install-fab { width: 2.9rem; height: 2.9rem; }
  .install-fab .icon { font-size: 1.05rem; }
  .info-btn { width: 2.8rem; height: 2.8rem; font-size: 1.15rem; }
}

@media (max-width: 340px) {
  .actions-container {
    top: max(calc(env(safe-area-inset-top, 0px) + 0.5rem), 0.5rem);
    right: max(calc(env(safe-area-inset-right, 0px) + 0.5rem), 0.5rem);
  }
  .install-fab { width: 2.7rem; height: 2.7rem; }
  .info-btn { width: 2.6rem; height: 2.6rem; }
}

.popup-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 2vw, 1.2rem);
  z-index: 10002;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}

.popup-card {
  position: relative;
  background: #ffffff;
  border-radius: 18px;
  padding: clamp(1rem, 3.5vw, 1.6rem);
  width: min(92vw, 380px);
  max-width: 100%;
  box-shadow: 0 16px 48px rgba(0,0,0,0.35);
  border: 2px solid #1976D2;
  color: #000;
  outline: none;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
}

.popup-card .popup-content {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.5rem;
  padding-right: 0.1rem;
}

.close-btn {
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  width: 2.2rem;
  height: 2.2rem;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff4d4d, #b71c1c);
  color: #fff;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  transition: transform .22s ease, box-shadow .22s ease;
  -webkit-tap-highlight-color: transparent;
}
.close-btn:hover { transform: scale(1.08) rotate(90deg); }

.popup-title {
  font-size: clamp(1.1rem, 3.5vw, 1.4rem);
  font-weight: 900;
  text-align: center;
  background: linear-gradient(90deg, #1976D2, #42A5F5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.75rem;
}
.arabic-steps {
  background: #f5f7fb;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid #dfe9ff;
  direction: rtl;
  text-align: right;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 0.95rem;
  line-height: 1.6;
}
.arabic-steps h4 { margin: 0 0 0.4rem; font-size: 1rem; }
.arabic-steps ol { margin: 0.1rem 0 0.75rem; padding-inline-start: 1.1rem; }
.arabic-steps li { margin-bottom: 0.35rem; }
.hint-text {
  margin-top: 0.35rem;
  font-size: 0.88rem;
  color: #374151;
}

.link-box {
  background: #e8f3ff;
  padding: 0.8rem;
  border-radius: 10px;
  border: 1px solid #1976D2;
  text-align: center;
  font-weight: bold;
  color: #000;
  margin-bottom: 0.6rem;
  word-break: break-all;
  cursor: pointer;
  user-select: all;
  outline: none;
}
.link-box:focus { box-shadow: 0 0 0 3px rgba(25,118,210,0.35); }

.copy-btn {
  width: 100%;
  padding: 0.8rem;
  background: linear-gradient(135deg, #1976D2, #42A5F5);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  box-shadow: 0 8px 20px rgba(25,118,210,0.3);
}
.copy-btn:disabled { opacity: 0.85; cursor: default; }

/* شريط التوجيه (استخدمنا نفس نمط التوست لديك) */
.toast {
  position: fixed;
  bottom: max(calc(env(safe-area-inset-bottom, 0px) + 0.9rem), 0.9rem);
  right: max(calc(env(safe-area-inset-right, 0px) + 0.9rem), 0.9rem);
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: #111827;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  box-shadow: 0 12px 30px rgba(0,0,0,0.35);
  z-index: 10001;
  border: 1px solid rgba(255,255,255,0.08);
  max-width: min(92vw, 420px);
}
.toast.success { background: linear-gradient(135deg, #16a34a, #22c55e); }
.toast.error { background: linear-gradient(135deg, #ef4444, #dc2626); }
.toast.warn { background: linear-gradient(135deg, #f59e0b, #d97706); }
.toast .toast-icon { font-size: 1.05rem; }

.fade-scale-enter-active, .fade-scale-leave-active { transition: all .22s ease; }
.fade-scale-enter-from, .fade-scale-leave-to { opacity: 0; transform: scale(0.96); }
.toast-fade-enter-active, .toast-fade-leave-active { transition: opacity .22s ease, transform .22s ease; }
.toast-fade-enter-from, .toast-fade-leave-to { opacity: 0; transform: translateY(10px); }

@media (prefers-color-scheme: dark) {
  .popup-card {
    background: #0b1220;
    color: #e5e7eb;
    border-color: #3b82f6;
    box-shadow: 0 16px 48px rgba(0,0,0,0.6);
  }
  .arabic-steps {
    background: #0f172a;
    border-color: #1f2a44;
  }
  .hint-text { color: #9ca3af; }
  .link-box {
    background: #0b1a2e;
    color: #e5e7eb;
    border-color: #3b82f6;
  }
  .copy-btn {
    background: linear-gradient(135deg, #2563eb, #3b82f6);
    box-shadow: 0 8px 20px rgba(37,99,235,0.35);
  }
}
</style>